import { EventBus } from '@/event'
import { mVMixin } from '@/mixins'

const releaseType = BUILDTYPE == 'PROD' ? 'prodv2' : 'betav1'
const releaseType1 = BUILDTYPE == 'PROD' ? 'prodv3' : 'betav1'

export const reports = {
    state: {
        baseUrl: `https://vdrm.mobiotics.com/${releaseType}/provider/v1/report`,
        auth: `Bearer ${localStorage.getItem('token')}`
    },
    getters: {},
    mutations: {},
    actions: {
        actGetReport(context, data) {
            EventBus.$emit('Loader', true)
            console.log('paload', JSON.stringify(data.filter))
            let queryParams = ""
            if (data.reportid === "job" || data.reportid === "package" || data.reportid === "keygen") {
                queryParams = `${mVMixin.methods.getParam(data.filter)}initiatedby=${context.getters.getReportInitiatedBy}`
                    // initiatedby=${context.getters.getReportInitiatedBy}
            } else if ((data.reportid === "usage")) {
                queryParams = `${mVMixin.methods.getParam(data.filter)}interval=${context.getters.getReportInterval}`
            } else {
                queryParams = `${mVMixin.methods.getParam(data.filter)}`
            }
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise((resolve, reject) => {
                fetch(`${context.state.baseUrl}/${data.reportid}?fromdate=${data.fromdate}&todate=${data.todate}&pagesize=${data.pagesize}&page=${data.page}&${queryParams}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }).then(Response => {
                    EventBus.$emit('Loader', false)
                    if (Response.ok) {
                        resolve(Response.json())
                    } else {
                        resolve(Response.json())
                    }
                }).catch(error => {
                    EventBus.$emit('Loader', false)
                    console.log(error)
                    reject(error)
                })
            })
        },
        actReportDownload(context, data) {
            let { id, dates } = data;
            let queryParams = ""
            if ((id === "usage")) {
                queryParams = `${mVMixin.methods.getParam(context.getters.getReportData)}&interval=${context.getters.getReportInterval}`
            } else if (id === "job" || id === "package" || id === "keygen") {
                queryParams = `${mVMixin.methods.getParam(context.getters.getReportData)}initiatedby=${context.getters.getReportInitiatedBy}`
            } else {
                queryParams = `${mVMixin.methods.getParam(context.getters.getReportData)}`
            }
            EventBus.$emit('Loader', true)
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise((resolve, reject) => {
                fetch(`${context.state.baseUrl}/${id}/download?todate=${dates.toDate}&fromdate=${dates.fromDate}&${queryParams}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }).then(Response => {
                    console.log(Response, 'response')
                    EventBus.$emit('Loader', false)
                    if (Response.ok) {
                        resolve(Response.text())
                    } else {
                        resolve(Response.json())
                    }
                }).catch(error => {
                    EventBus.$emit('Loader', false)
                    console.log(error)
                    reject(error)
                })
            })
        },
        actListProvider(context, data) {
            let params = `${mVMixin.methods.getParam(data)}`
            EventBus.$emit('Loader', true)
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise(function(resolve, reject) {
                fetch(`${context.getters.getloginUrl}/user?${params}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },
        getProviderSubUser(context, serviceid) {
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise((resolve, reject) => {
                fetch(`${context.getters.getloginUrl}/user/${serviceid}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        }
                    })
                    .then(response => {
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            reject(response)
                        }
                    }).catch(error => {
                        reject(error)
                    })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/reports.js